// extracted by mini-css-extract-plugin
export default {"errorContainer":"TransactionModalErrors_errorContainer__S2u9Y","errorMessage":"TransactionModalErrors_errorMessage__Dvk7N"};